/**
 * The single client-side product version, injected at build time from
 * package.json via the vite `define` below — never hand-maintained
 * (D-BANK-UX-02: the shell footer had drifted to a hardcoded "v2.0").
 *
 * The typeof guard keeps non-vite runtimes (jest/jsdom) working: they render
 * the honest fallback instead of throwing a ReferenceError.
 */

declare const __APP_VERSION__: string | undefined;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' && __APP_VERSION__ ? __APP_VERSION__ : '';

export const APP_VERSION_LABEL: string = APP_VERSION
  ? `DATA Compass v${APP_VERSION}`
  : 'DATA Compass';
